import { useQuery } from 'react-query';

import { portalApi } from '../api';

import mailgunLogKeys from './models/mailgunLogs/keys';
import { camelCaseApiResponse } from './util';

/* QUERIES
========================================================= */

/**
 * PINS admin: trace Mailgun delivery logs (suppressions + events + verdict)
 * for a recipient email address. Each query is a live Mailgun API call, so
 * callers must gate it behind an explicit search submit via `enabled`.
 */
// eslint-disable-next-line import/prefer-default-export
export const useMailgunLogs = ({ email = '', days = 7 } = {}, options = {}) => useQuery(
  mailgunLogKeys.trace(email, days),
  () => camelCaseApiResponse(() => portalApi.getMailgunLogs({ email, days })),
  {
    enabled: false,
    retry: false,
    ...options
  }
);
